import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { EditText } from '../../../../component/ui/edit-text/edit-text';
import { SecurityGroupEntity } from '../../../../api/types/settings/permissions/security-group-entity';
import { updateSecurityGroupOperation } from '../operations/update-security-group-operation';

interface EditSecurityGroupDialogProps {
  visible: boolean;
  group: SecurityGroupEntity | null;
  onHide: () => void;
  onUpdated: () => void;
}

export const EditSecurityGroupDialog: React.FC<
  EditSecurityGroupDialogProps
> = ({ visible, group, onHide, onUpdated }) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      setName(group?.name ?? '');
      setLoading(false);
    }
  }, [visible, group]);

  const handleSubmit = async () => {
    if (!group) {
      return;
    }

    await updateSecurityGroupOperation(group.id, { name }, setLoading, () => {
      onUpdated();
      onHide();
    });
  };

  const footer = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '8px',
      }}
    >
      <Button
        label="ביטול"
        icon="pi pi-times"
        onClick={onHide}
        className="p-button-text"
        disabled={loading}
      />
      <Button
        label="שמירה"
        icon="pi pi-check"
        onClick={handleSubmit}
        loading={loading}
        disabled={loading || !group}
      />
    </div>
  );

  return (
    <Dialog
      header="עריכת קבוצת הרשאות"
      visible={visible}
      onHide={onHide}
      style={{ width: '560px', maxWidth: '95vw' }}
      footer={footer}
      dismissableMask
      draggable={false}
      resizable={false}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          direction: 'rtl',
          paddingTop: '4px',
        }}
      >
        <EditText
          title="שם הקבוצה"
          value={name}
          onChange={setName}
          maxLength={128}
        />
      </div>
    </Dialog>
  );
};
